var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("日均运费，发票折线图")]),_c('div',{style:({width: '100%', height: '300px'}),attrs:{"id":"freight"}})])}
var staticRenderFns = []

export { render, staticRenderFns }